import list from './list'
import pager from './pager'
import notfound from './notfound'

export default {
  list,
  pager,
  notfound
}
